// File: src/app/core/interfaces/email-preview.interface.ts
// ============================================
// EMAIL PREVIEW DATA INTERFACE
// ============================================

/**
 * Standard interface for email preview data
 * All components should map their data to this format
 */
export interface EmailPreviewData {
  campaignName?: string;
  recipientName?: string;
  senderName?: string;
  senderEmail?: string;
  subject?: string;
  scheduledDateTime?: string;
  emailBody?: string;
  attachments?: any;
  campaign_description?: string;
  
  // Optional additional metadata
  metadata?: {
    [key: string]: any;
  };
}

/**
 * Configuration options for preview window
 */
export interface PreviewWindowConfig {
  width?: number;
  height?: number;
  windowName?: string;
  features?: string;
}

/**
 * Default window configuration
 */
export const DEFAULT_PREVIEW_CONFIG: PreviewWindowConfig = {
  width: 1000,
  height: 800,
  windowName: 'EmailPreview',
  features: 'menubar=no,toolbar=no,location=no,status=no,scrollbars=yes,resizable=yes'
};